import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/design-system/detail-card-shell')({
  component: () => <Navigate to="/design-system/card" />,
});
